import { StratNodesReq, StratNodesDef } from "./type/strat-nodes-def";
import { DistributeReq, DistributeDef } from "./type/distribute-def";
import { InspectionReq, InspectionDef } from "./type/inspection-def";
import { RelevanceReq, RelevanceDef } from "./type/relevance-def";
import {
  SetStratBoundsReq,
  StratBoundsReq,
  StratBoundsDef,
} from "./type/strat-bounds-def";
import {
  RobustnessReq,
  RobustnessDef,
  RobustnessStatusDef,
  RobustnessResultDef
} from "./type/robustness-def";
import { ExDoDwReq, ExDoDwDef } from "./type/report/ex-do-dw";
import { PublishExDoDef } from "./type/report/publish-ex-do";
import { GeneratePDFDef } from "./type/report/generate-pdf";
import { BatchEditReq, BatchEditDef } from "./type/batch-edit"

import { StratBoundsAdapter } from "./adapter/strat-bounds-def";
import { StratNodesAdapter } from "./adapter/strat-nodes-def";
import { DistributeAdapter } from "./adapter/distribute-def";
import { InspectionAdapter } from "./adapter/inspection-def";
import { RelevanceAdapter } from "./adapter/relevance-def";
import { RobustnessAdapter } from "./adapter/robustness-def";
import { ExDoDwAdapter } from "./adapter/report/ex-do-dw";
import { PublishExDoAdapter } from "./adapter/report/publish-ex-do-dw";
import { InterventionDistributionAdapter } from "./adapter/intervention-distribution-def";
import { GeneratePDFAdapter } from "./adapter/report/generate-pdf";
import { BatchEditAdapter } from "./adapter/batch-edit"


import { IGraphRepo } from "./irepo";

import { TError } from "../../types/error";

export class GraphUsecase {
  private repo: IGraphRepo;
  private error: (error: TError) => void;

  constructor(repo: IGraphRepo, error: (error: TError) => void) {
    this.repo = repo;
    this.error = error;
  }

  async fetchRelevanceDef(req: RelevanceReq): Promise<RelevanceDef> {
    try {
      const dto = RelevanceAdapter.toInputDTO(req);
      const data = await this.repo.fetchRelevanceDef(dto);
      return RelevanceAdapter.toOutputDTO(data);
    } catch (error) {
      this.error({ id: null, error });
      throw error;
    }
  }

  async fetchStratNodesDef(req: StratNodesReq): Promise<StratNodesDef> {
    try {
      const dto = StratNodesAdapter.toInputDTO(req);
      const data = await this.repo.fetchStratNodesDef(dto);
      return StratNodesAdapter.toOutputDTO(data);
    } catch (error) {
      this.error({ id: null, error });
      throw error;
    }
  }

  async fetchStratBoundsDef(req: StratBoundsReq): Promise<StratBoundsDef> {
    try {
      const dto = StratBoundsAdapter.toInputDTO(req);
      const data = await this.repo.fetchStratBoundsDef(dto);
      return StratBoundsAdapter.toOutputDTO(data);
    } catch (error) {
      this.error({ id: null, error });
      throw error;
    }
  }

  async setStratBoundsDef(req: SetStratBoundsReq): Promise<any> {
    try {
      const dto = StratBoundsAdapter.toUpdateInputDTO(req);
      const data = await this.repo.setStratBoundsDef(dto);
      return StratBoundsAdapter.toOutputDTO(data);
    } catch (error) {
      this.error({ id: null, error });
      throw error;
    }
  }

  async deleteStratBoundsDef(req: StratBoundsReq): Promise<any> {
    try {
      const dto = StratBoundsAdapter.toInputDTO(req);
      const data = await this.repo.deleteStratBoundsDef(dto);
      return StratBoundsAdapter.toOutputDTO(data);
    } catch (error) {
      this.error({ id: null, error });
      throw error;
    }
  }

  async fetchDistributeDef(req: DistributeReq): Promise<DistributeDef> {
    try {
      const dto = DistributeAdapter.toInputDTO(req);
      const data = await this.repo.fetchDistributeDef(dto);
      return DistributeAdapter.toOutputDTO(data);
    } catch (error) {
      this.error({ id: null, error });
      throw error;
    }
  }

  async fetchInspectionDef(req: InspectionReq): Promise<InspectionDef> {
    try {
      const dto = InspectionAdapter.toInputDTO(req);
      const data = await this.repo.fetchInspectionDef(dto);
      return InspectionAdapter.toOutputDTO(data);
    } catch (error) {
      this.error({ id: null, error });
      throw error;
    }
  }

  async fetchRobustnessDef(model_id: string, req: RobustnessReq): Promise<RobustnessDef> {
    try {
      const dto = RobustnessAdapter.toInputDTO(req);
      const data = await this.repo.fetchRobustnessDef(model_id, dto);
      return RobustnessAdapter.toOutputDTO(data);
    } catch (error) {
      this.error({ id: null, error });
      throw error;
    }
  }

  async fetchRobustnessStatus(task_id: string): Promise<RobustnessStatusDef> {
    try {
      const data = await this.repo.fetchRobustnessStatus(task_id);
      return RobustnessAdapter.toOutputStatusDTO(data);
    } catch (error) {
      this.error({ id: null, error });
      throw error;
    }
  }

  async fetchRobustnessResult(task_id: string): Promise<RobustnessResultDef> {
    try {
      const data = await this.repo.fetchRobustnessResult(task_id);
      return RobustnessAdapter.toOutputResultDTO(data);
    } catch (error) {
      this.error({ id: null, error });
      throw error;
    }
  }

  async fetchExDoDw(model_id: string, req: ExDoDwReq): Promise<ExDoDwDef> {
    try {
      const dto = ExDoDwAdapter.toInputDTO(req);
      const data = await this.repo.fetchExDoDw(model_id, dto);
      return ExDoDwAdapter.toOutputDTO(data);
    } catch (error) {
      this.error({ id: null, error });
      throw error;
    }
  }

  async fetchPublishExDo(report_id: string): Promise<PublishExDoDef> {
    try {
      const data = await this.repo.fetchPublishExDo(report_id);
      return PublishExDoAdapter.toOutputDTO(data);
    } catch (error) {
      this.error({ id: null, error });
      throw error;
    }
  }

  async fetchInterventionDistribution(model_id: string, node_value: string): Promise<any> {
    try {
      const data = await this.repo.fetchInterventionDistribution(model_id, node_value);
      return InterventionDistributionAdapter.toOutputDTO(data);
    } catch (error) {
      this.error({ id: null, error });
      throw error;
    }
  }

  async fetchGeneratePDF(req: GeneratePDFDef): Promise<any> {
    try {
      const data = await this.repo.fetchGeneratePDF(req);
      return GeneratePDFAdapter.toOutputDTO(data);
    } catch (error) {
      this.error({ id: null, error });
      throw error;
    }
  }

  async fetchBatchEdit(model_id: string, req: BatchEditReq): Promise<ExDoDwDef> {
    try {
      const dto = BatchEditAdapter.toInputDTO(req);
      const data = await this.repo.fetchBatchEdit(model_id, dto);
      return BatchEditAdapter.toOutputDTO(data);
    } catch (error) {
      this.error({ id: null, error });
      throw error;
    }
  }

}